import { Component } from '@angular/core';
import { BaseDefaultListFilterComponent } from 'yt-ng-framework';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'filter-with-povezan-dokument',
    templateUrl: './filter-with-povezan-dokument.component.html'
})
export class FilterWithPovezanDokumentComponent extends BaseDefaultListFilterComponent {

    constructor(protected datePipe: DatePipe
    ){
        super(datePipe);
    }

    ngOnInit(){
        this.SetInitParameters();
    }

    SetFilterDescription(){
        super.SetFilterDescription();
        let _povezan:string = this.filterFormGroup.get('Povezan').value == true ? 'DA' : 'NE';
        let _datumOd:NgbDate = this.filterFormGroup.get('DateFrom').value;
        let _datumDo:NgbDate = this.filterFormGroup.get('DateTo').value;

        let _tekstDatumOd = _datumOd ? 'Od: ' + this.GetPropertyValue(_datumOd, 'date') : '';
        let _tekstDatumDo = _datumDo ? ' Do: ' + this.GetPropertyValue(_datumDo, 'date') : '';

        this.FilterDescription =  _tekstDatumOd + _tekstDatumDo +
                                 ' Uzmi samo povezane sa drugim dokumentima: ' + _povezan;
    }

    SetInitParameters(){
        super.SetInitParameters();
        let date = new Date();
        this.filterFormGroup = new FormGroup({
            // DateFrom: new FormControl(new NgbDate(date.getFullYear(), 1, 1), [Validators.required]),
            DateFrom: new FormControl(null, [Validators.required]),
            DateTo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()), [Validators.required]),
            Povezan: new FormControl()
        })
    }
}